import { setShouldRedirect } from "@redux/actions/common-actions";
import { NavigateFunction } from "react-router-dom";
import { Dispatch } from "redux";

export const navigateToUtilWithQueryParameters = (route: string, navigateFn: NavigateFunction, currLocation: string, queryParameters: string) => {
    if (currLocation.includes("axnui") && !route.includes("axnui")) {
        navigateFn({
            pathname: `/axnui${route}`,
            search: queryParameters
        });
    } else {
        navigateFn({
            pathname: route,
            search: queryParameters
        });
    }
}

export const handleNavigationForError = (dispatch: Dispatch) => (
    redirectToCallbackUrlOnError: boolean,
    oidcCallbackURL: string,
    asi: string,
    route: string,
    navigateFn: any,
    currLocation: string,
    queryParameters: string,
    error: {
        forwardedErrorCode?: string;
        forwardedErrorDescription?: string;
    }
) => {
    if (redirectToCallbackUrlOnError && oidcCallbackURL !== null) {
        dispatch(setShouldRedirect(true));

        setTimeout(() => {
            let url = `${oidcCallbackURL}?error=`;

            if (error?.forwardedErrorCode) {
                url += `${error.forwardedErrorCode}`
            } else {
                url += `server_error`;
            }

            url += `&error_description=`;

            if (error.forwardedErrorDescription) {
                url += `${error.forwardedErrorDescription}`;
            } else {
                url += `An error occurred`;

                if (asi) {
                    url += ` ASI: ${asi}`;
                }
            }

            window.location.href = url;
        }, 100);

    } else {
        navigateToUtilWithQueryParameters(route, navigateFn, currLocation, queryParameters);
    }
};
